import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MainDialogComponent } from './main dialog/main-dialog.component';

@Component({
  selector: 'user-search-preferences',
  template: `
    <div class="w-full bg-white">
      <form
        [formGroup]="InputForm"
        #PrefForm="ngForm"
        class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
        (ngSubmit)="Submit(PrefForm)"
      >
        <div class="mb-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
          >
            Search Terms
          </label>
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="{{inputData}}"
            formControlName="preferences"
          />
        </div>
        <div class="flex items-center justify-between">
          <button
            class="bg-evaluationto hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            (click)="Submit(PrefForm)"
          >
            Add/Update
          </button>
        </div>
      </form>
    </div>
  `,
})
export class UserPreferencesComponent {
  inputData: any = [];
  InputForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<MainDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder
  ) {
    this.inputData = this.data.dialogConfig.data.data ? this.data.dialogConfig.data.data : 'Add user preferences';
  }

  ngOnInit() {
    this.InputForm = this._formBuilder.group({
      preferences: ['', [Validators.required]],
    });
    this.InputForm.controls.preferences.setValue(this.inputData)
  }

  cancel() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  Submit(form: NgForm) {
    this.dialogRef.close(form.value.preferences);
  }
}
